import { DashboardWidget, LayoutItem } from "@/types/breeze/Dashboard";

export interface RemapResult {
  json: string | null;
  changed: boolean;
}

// Pairs widgets by index (both arrays must be sort_order-ordered) to rewrite temp ids in layout_json.
// Returns `{ json: null, changed: true }` on corrupt JSON so the caller drops it.
export function remapLayoutWidgetIds(
  localWidgets: DashboardWidget[],
  savedWidgets: DashboardWidget[],
  layoutJson: string | null,
): RemapResult {
  if (!layoutJson) return { json: layoutJson, changed: false };

  const idRemap = new Map<number, number>();
  localWidgets.forEach((w, i) => {
    const realId = savedWidgets[i]?.id;
    if (realId != null && w.id !== realId) idRemap.set(w.id, realId);
  });
  if (idRemap.size === 0) return { json: layoutJson, changed: false };

  let parsed: LayoutItem[];
  try {
    const decoded = JSON.parse(layoutJson);
    if (!Array.isArray(decoded)) return { json: null, changed: true };
    parsed = decoded as LayoutItem[];
  } catch {
    return { json: null, changed: true };
  }

  const rewritten = parsed.map((l) => ({
    ...l,
    widgetId: idRemap.get(l.widgetId) ?? l.widgetId,
  }));
  const next = JSON.stringify(rewritten);
  return { json: next, changed: next !== layoutJson };
}
